import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Row, Col, Card, CardBody, CardTitle } from "reactstrap";

// Backend
import { getDashboardDetail } from "connection/backend";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Widget from "./Widget";
import Actions from "./Actions";
import Apaexlinecolumn from "./apaexlinecolumn";

const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const response = await getDashboardDetail();
    const data = response.data;
    setDashboard({
      daily_income: data.daily_income,
      daily_debts: data.daily_debts,
      daily_animals: data.daily_animals,
      daily_tours: data.daily_tours,
      cash: data.cash,
      bank: data.bank,
      daily_balance: data.daily_balance,
    });
  };

  const [dashboard, setDashboard] = useState({
    daily_income: 0,
    daily_debts: 0,
    daily_animals: 0,
    daily_tours: 0,
    cash: 0,
    bank: 0,
    daily_balance: 0,
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Dashboard </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Dashboard"} />
          {user.group === "Administrador" ||
          user.group === "Gerencia" ||
          user.group === "Recaudo" ? (
            <Widget data={dashboard} />
          ) : null}
          <Actions group={user.group} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
